import React from "react";
import { ReactRenderer } from "./lib/ReactRenderer";
import DateUtility from "./lib/dateUtility";
import { FILM_PAGE, FilmPoster, fetchFilms, filmUrl, whenText } from "./lib/film";
/**
 * "Film" on the front page (boards Forside and Forside - bred skaerm): a poster for each film
 * playing now and when it is next shown, in a row that scrolls sideways. A poster opens the film's
 * page; "Se alle" opens the Film page with the films that are coming as well.
 */
export default class FilmStripComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isLoaded: false, films: [], error: null };
    }
    componentDidMount() {
        fetchFilms()
            .then((result) => this.setState({ isLoaded: true, films: result.nowShowing, error: null }))
            .catch((error) => this.setState({ isLoaded: true, films: [], error: error.message }));
    }
    content() {
        if (!this.state.isLoaded) {
            return React.createElement("div", { className: "bi-film-strip-empty" },
                React.createElement("i", { className: "fa-regular fa-spinner-third fa-spin" }));
        }
        if (this.state.error) {
            return React.createElement("p", { className: "bi-sl-empty bi-sl-empty-card" }, this.state.error);
        }
        const films = this.state.films;
        if (films.length === 0) {
            return React.createElement("p", { className: "bi-sl-empty bi-sl-empty-card" }, "Der spiller ingen film lige nu.");
        }
        return (React.createElement("div", { className: "bi-film-strip" },
            films.map((film) => (React.createElement("a", { key: film.id, className: "bi-film-strip-card", href: filmUrl(film.id) },
                React.createElement(FilmPoster, { id: film.id, lastWeek: film.isLastWeek }),
                React.createElement("span", { className: "bi-film-strip-title" }, film.title),
                React.createElement("span", { className: "bi-film-strip-next" }, whenText(DateUtility.parse(film.nextShow)))))),
            React.createElement("a", { className: "bi-film-strip-card", href: FILM_PAGE, "aria-label": "Se alle film" },
                React.createElement("span", { className: "bi-film-poster bi-film-strip-all" }, "Se alle"))));
    }
    render() {
        return (React.createElement("section", { className: "bi-sl-section bi-film-section" },
            React.createElement("div", { className: "bi-sl-section-head" },
                React.createElement("h2", null, "Film"),
                React.createElement("a", { href: FILM_PAGE }, "Se alle")),
            this.content()));
    }
}
ReactRenderer.render("filmstripcomponent", (elem) => React.createElement(FilmStripComponent, Object.assign({}, elem.dataset)));
